import moment from "moment";

export const getDiffDateDaysHours = (startDate, endDate ) => 
moment.utc(moment(endDate || Date.now.utc).diff(moment(startDate))).format("HH:mm:ss")
